export const App = {
    // api: 'http://localhost/eusystem-backend/public/api/'
    api: 'https://service.eusystem.eu/api/',
    // api: 'http://192.168.1.25/eusystem-backend/public/api/',
} 